<template>
  <div class="invoices">
    <va-card :title="$t('invoices.cards.title')">
      <div class="row">
        <div class="flex md12">
          <va-input
            v-model="email"
            :label="$t('invoices.forms.emailE2ELabel')"
            :placeholder="$t('invoices.forms.emalE2EPlaceholder')"
          />
        </div>
      </div>
      <va-data-table
        :fields="fields"
        :data="invoices"
        :per-page="perPage"
        :totalPages="totalPages"
        :loading="loading"
        @page-selected="showMore"
        no-data-label="Sem Dados Cadastrados"
        api-mode
      >
        <template slot="actions" slot-scope="props">
          <va-button
            :to="{
              name: 'invoice-transactions',
              params: {
                invoiceId: props.rowData.id,
              }
            }"
          > {{ $t('invoices.action') }}</va-button>
        </template>
      </va-data-table>
    </va-card>
  </div>
</template>

<script>
import gql from 'graphql-tag'
const perPage = 20
export default {
  name: 'invoices',
  methods: {
    showMore (page) {
      this.loading = true
      this.page = page
      this.$apollo.queries.invoices.fetchMore({
        variables: {
          page: (page - 1) * this.perPage,
          perPage: this.perPage,
        },
        updateQuery: (_, { fetchMoreResult }) => {
          this.loading = false
          return fetchMoreResult
        },
      })
    },
  },
  data () {
    return {
      invoices: [],
      email: '',
      page: 1,
      perPage: perPage,
      pages: null,
      loading: false,
    }
  },
  apollo: {
    invoices: {
      query: gql`
      query MyQuery($page: Int = 0, $perPage: Int = 2, $busca: String! = "%%") {
        invoices: invoice(
            limit: $perPage,
            offset: $page,
            where: {_or: [{client: {email: {_ilike: $busca}}}, {transactions: {e2e: {_ilike: $busca}}}]},
            order_by: {id: desc}
          ) {
          id
          client {
            id
            email
          }
          gateway
          gnid
          last_transaction
          created_at
          plan {
            id
            name
          }
        }
      }
      `,
      variables () {
        return {
          perPage,
          page: 0,
          busca: this.emailSearch,
        }
      },
    },
    pages: gql`
    query MyQuery {
      pages: invoice_aggregate {
        aggregate {
          count
        }
      }
    }
    `,
  },
  computed: {
    totalPages () {
      return this.pages != null ? Math.ceil(this.pages.aggregate.count / this.perPage) : 0
    },
    emailSearch () {
      return '%' + this.email.trim() + '%'
    },
    fields () {
      const moment = this.$moment
      return [{
        name: 'id',
        title: this.$t('tables.id'),
        width: '50px',
      }, {
        name: 'client',
        title: this.$t('invoices.headings.client'),
        width: '35%',
        callback (value) {
          return value.email
        },
      }, {
        name: 'gateway',
        title: this.$t('invoices.headings.gateway'),
        width: '10%',
      }, {
        name: 'plan',
        title: this.$t('invoices.headings.plan'),
        width: '10%',
        callback (value) {
          return value.name
        },
      }, {
        name: 'gnid',
        title: this.$t('invoices.headings.gnid'),
        width: '10%',
      }, {
        name: 'created_at',
        title: this.$t('invoices.headings.created_at'),
        width: '10%',
        callback (value) {
          return moment(value).format('DD/MM/YYYY [as] HH:mm:ss')
        },
      }, {
        name: 'last_transaction',
        title: this.$t('invoices.headings.last'),
        width: '10%',
      }, {
        name: '__slot:actions',
        title: this.$t('tables.actions'),
      }]
    },
  },
  mounted () {
    if (Object.keys(this.$apollo.queries).includes('invoices')) {
      this.$apollo.queries.pages.refetch()
      this.$apollo.queries.invoices.refetch()
    }
  },
}
</script>

<style lang="scss">
</style>
